






































import { defineComponent, ref } from '@vue/composition-api';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { createCommunity } from '@front-app/services/CommunityApi/CommunityApi';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import EditorWrapper from '@front-app/components/layouts/form/EditorWrapper.vue';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';

export default defineComponent({
	components: {
		FormSection,
		FormInput,
		FormLabel,
		FormError,
		EditorWrapper,
		SlidingPanel,
	},
	setup(props, ctx) {
		const name = ref('');
		const validation = v({
			name: {
				value: name,
				rules: [required()],
			},
		});

		const {
			track,
			isLoading,
			isError,
			isSuccess,
		} = useAsyncStatus();

		const {
			focusFirstInvalid,
		} = useFocusFirstInvalidField({ containerSelector: '.community__create-form' });

		const saveCommunity = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}
			const result = await track(createCommunity({
				name: name.value,
			}));
			ctx.emit('created', result);
		};

		return {
			validation,
			name,
			saveCommunity,
			// State
			isLoading,
			isError,
			isSuccess,
		};
	},
});
